import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Spin,
  Switch,
  message,
} from "antd";
import { getGetnet, upsertGetnet } from "./api";
import { GetnetConfig } from "./types";

interface Props {
  sellerCode: string;
}

export const GetnetCard: React.FC<Props> = ({ sellerCode }) => {
  const [form] = Form.useForm<GetnetConfig>();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getGetnet(sellerCode);
      form.setFieldsValue(data);
    } catch {
      message.error("No se pudo cargar Getnet");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sellerCode) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerCode]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await upsertGetnet(sellerCode, values);
      message.success("Getnet guardado");
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || "Error al guardar";
      message.error(Array.isArray(msg) ? msg.join(" • ") : msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title="Getnet"
      extra={
        <Button type="primary" loading={saving} onClick={handleSave}>
          Guardar
        </Button>
      }
      style={{ marginBottom: 16 }}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="Habilitado" name="enabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Modo producción" name="productionModeEnabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Título (opcional)" name="title">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Descripción (opcional)" name="description">
            <Input />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Client ID" name="clientId">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Secret ID" name="secretId">
                <Input.Password placeholder="••••••••" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Webhook user" name="userWebhook">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Webhook password" name="passwordWebhook">
                <Input.Password placeholder="••••••••" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Card>
  );
};
